// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PPZq","field":"styles_field__NzMYD","fieldCol":"styles_fieldCol__epVL7","diffCol":"styles_diffCol__2uO9r","diff":"styles_diff__1qeAI"};